<template>
    <div class="tab-pane fade" id="notes">
        <div class="card-table mb-0">
            <div v-if="newrecord" class="card">
                <div style="padding: 20px; display: flex; justify-content: space-between; align-items: center;">
                    <div ref="newNoteContainer" style="display: flex; align-items: center;">
                        <img :src="profileImageUrl || defaultImageUrl" alt="User Image" class="avatar rounded-circle"
                            style="width: 50px; height: 50px; object-fit: cover; margin-right: 15px;" />
                        <div>
                            <h5 style="text-align: left; margin: 0 0 4px 0;">Notes</h5>
                            <transition name="fade">
                                <h7 style="text-align: left; margin: 0;">{{ getCurrentDate() }}
                                </h7>

                            </transition>
                        </div>
                    </div>

                    <!-- <div class="button-container">
                        <button class="btn btn-danger" @click="deleteNoteNew">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div> -->
                </div>
                <div v-if="newrecord" class="card-body" style="padding: 20px;">
                    <!-- <h5
                        style="text-align: left; margin: 0; color: gray; font-weight: normal; font-family: 'Times New Roman', serif; font-size:17px;">
                        Click on
                        text to add note....</h5> -->
                    <transition name="fade-slide">
                        <p @click="makeEditablex" @blur="makeNonEditablex" contenteditable="false"
                            class="editable-text">
                            {{ text }}
                        </p>
                    </transition>
                </div>
            </div>

            <div v-for="note in notedata" :key="note.slno">
                <div class="card">
                    <transition name="fade-slide">
                        <div ref="newNoteContainerDel"
                            style="padding: 20px; display: flex; justify-content: space-between; align-items: center;">

                            <div style="display: flex; align-items: center;">
                                <img :src="profileImageUrl || defaultImageUrl" alt="User Image"
                                    class="avatar rounded-circle"
                                    style="width: 50px; height: 50px; object-fit: cover; margin-right: 15px;" />
                                <div>
                                    <h5 style="text-align: left; margin: 0 0 4px 0; font-size: 17px;">{{
                                            formatDateTime(note.createddate) }}
                                    </h5>
                                    <h5 v-if="note.modifieddate" style="text-align: left; margin: 0 0 4px 0; font-size: 13px;color:grey">
                                        {{
                                            formatModDateTime(note.modifieddate) }}
                                    </h5>
                                    <transition name="fade">
                                        <h7 v-if="!note.createddate" style="text-align: left; margin: 0;">{{
                                            getCurrentDate() }}
                                        </h7>
                                    </transition>
                                    <!-- <transition name="fade">
                                        <p v-if="!note.modifieddate"
                                            style="text-align: left; margin: 0; display: block; font-size: 13px;color:grey">
                                            {{
                                                formatDateTime(note.createddate) }}</p>
                                    </transition>
                                    <transition name="fade">
                                        <p v-if="note.modifieddate"
                                            style="text-align: left; margin: 0; display: block; font-size: 13px; color:grey">
                                            {{
                                                formatModDateTime(note.modifieddate) }}</p>
                                    </transition> -->
                                </div>
                            </div>

                            <div class="button-container">
                                <button class="btn btn-danger" @click="deleteNote(note.slno)">
                                    <i class="fas fa-trash"></i>
                                </button><button v-if="!newrecord" style="margin-left:15px" class="btn btn-primary"
                                    @click="addNote()">
                                    <i class="fas fa-plus"></i>
                                </button>

                            </div>

                        </div>
                    </transition>

                    <div class="card-body" style="padding: 20px;">
                        <!-- <h5
                        style="text-align: left; margin: 0; color: gray; font-weight: normal; font-family: 'Times New Roman', serif; font-size:17px;">
                        Click on
                        text to add note....</h5> -->
                        <transition name="fade-slide">
                            <p @click="makeEditable($event, note.slno)" @blur="makeNonEditable($event, note.slno)"
                                contenteditable="false" class="editable-text">
                                {{ note.notes || text }}
                            </p>
                        </transition>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import dmedicalrecords from "@/assets/json/doctor/dmedicalrecords.json";
import axios from "axios";
import Swal from "sweetalert2";
import defaultImageUrl from "@/assets/img/doctors/doctor-thumb-01.jpg";
import { TreeSelectNode } from "ant-design-vue";
export default {

    props: {
        patientId: {
            type: String,
            required: true,
        },
        doctorId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            dmedicalrecords: dmedicalrecords,
            medical_records: [],
            text: "Click on text to add note....",
            isEditable: null,
            createdatetime: "",
            modifieddatetime: "",
            notedata: [],
            slno: null,
            profileImageUrl: "",
            defaultImageUrl: defaultImageUrl,
            newrecord: false,
        };
    },
    methods: {
        addNote() {
            this.newrecord = true;
            this.$nextTick(() => {
                const targetElement = this.$refs.newNoteContainer;
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            });
        },

        deleteNoteNew() {
            this.newrecord = false;
            this.$nextTick(() => {
                const targetElement = this.$refs.newNoteContainerDel;
                if (targetElement && targetElement.$el) {
                    targetElement.$el.scrollIntoView({ behavior: "smooth", block: "center" });
                } else if (targetElement instanceof HTMLElement) {
                    targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            });
        },
        getCurrentDate() {
            const now = new Date();
            const options = { year: "numeric", month: "long", day: "numeric" };
            return now.toLocaleDateString("en-US", options);
        },
        async fetchDoctorProfileImage() {
            try {
                const profiledoctorid = sessionStorage.getItem("userdbid");
                const response = await axios.get(
                    `doctors/doctorimg/${profiledoctorid}/download`,
                    {
                        responseType: "arraybuffer"
                    }
                );

                const objectURL = window.URL.createObjectURL(new Blob([response.data]));
                this.profileImageUrl = objectURL;
            } catch (error) {
                console.error("Error fetching patient profile image:", error);
            }
        },
        formatDateTime(isoString) {
            let date = new Date(isoString);
            let options = {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true
            };

            return `Created on ${date.toLocaleDateString("en-US", options)}`;
        },
        formatModDateTime(isoString) {
            let date = new Date(isoString);
            let options = {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true
            };

            return `Modified on ${date.toLocaleDateString("en-US", options)}`;
        },
        makeEditablex(event) {
            const element = event.target;
            if (element.innerText.trim() === "Click on text to add note....") {
                element.innerText = "";
            }
            element.contentEditable = true;
            element.focus();
        },
        async makeNonEditablex(event) {
            const element = event.target;
            this.text = element.innerText.trim();
            console.log()
            element.contentEditable = false;
            await this.saveNote(null, this.text);
        },
        makeEditable(event, slno) {
            this.isEditable = slno;
            const element = event.target;
            if (element.innerText.trim() === "Click on text to add note....") {
                element.innerText = "";
            }
            element.contentEditable = true;
            element.focus();
        },
        async makeNonEditable(event, slno) {
            this.isEditable = null;
            const element = event.target;
            element.contentEditable = false;
            const updatedText = element.innerText.trim();
            const noteIndex = this.notedata.findIndex(note => note.slno === slno);
            if (noteIndex !== -1) {
                this.notedata[noteIndex].notes = updatedText;
            }

            await this.saveNote(slno, updatedText);
        },
        async saveNote(slno, noteContent) {
            try {
                const payload = {
                    slno: slno || null,
                    notes: noteContent,
                };
                await axios.post(
                    `/doctors/${this.doctorId}/patients/${this.patientId}/notes`,
                    payload
                );
                this.newrecord = false;
                await this.fetchNotes();
            } catch (error) {
                console.error("Error saving note:", error);
            }
        },
        async fetchNotes() {
            // sessionStorage.getItem("userdbid");
            // ${this.patientid}
            try {
                const response = await axios.get(
                    `/doctors/${this.doctorId}/patients/${this.patientId}/notes`
                );
                this.notedata = response.data;
                this.newrecord = false;
                this.text = "Click on text to add note....";
            } catch (error) {
                console.error("Error fetching notes:", error);
                this.newrecord = true;
                this.notedata = [];
            }
        },
        async deleteNote(slno) {
            try {
                const response = await axios.delete(`/doctors/${this.doctorId}/notes/${slno}`);
                this.text = "";
                this.createdatetime = "";
                this.modifieddatetime = "";
                await this.fetchNotes();
                    if (!this.notedata || this.notedata.length === 0) {
                        this.notedata = [];
                        this.newrecord = true;
                        this.text = "Click on text to add note....";
                    }
            } catch (error) {
                console.error("Error deleting note:", error);
            }
        },
    },
    mounted() {
        this.fetchDoctorProfileImage();
        this.fetchNotes();
    },

};
</script>
<style>
.no-bold {
    font-weight: normal !important;
}

.editable-text {
    cursor: pointer;
    border: 2px solid transparent;
    font-family: "Times New Roman", sans-serif;
    font-size: 18px;
    padding-bottom: 60px;
}

.editable-text:focus {

    outline: none;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.button-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

@media (max-width: 576px) {
    .button-container {
        flex-direction: column;
        align-items: center;
    }

    .add-btn {
        margin-left: 0 !important;
        margin-top: 10px;
    }
}

@media (max-width: 768px) {
    .button-container {
        justify-content: center;
    }
}

</style>